import * as React from 'react';
import GeneralConfig from './GeneralConfig';

const GeneralConfigContext = React.createContext<GeneralConfig>({
  localeCode: 'en-GB',
  resources: [],
});

export default GeneralConfigContext;
